import {changeEvent} from "../../webpack/modules/events";

changeEvent('.only-integers', true, function(element) {
    element.value = parseInt(element.value);
});